export const SERVICE_NAME = "GitScope";
